export default __webpack_public_path__ + "static/media/tree.c349bcea.svg";